const modalPortalCss = `
.gallery-modal-overlay {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(0, 0, 0, 0.55);
  z-index: 9999;
}

.gallery-modal {
  position: relative;
  width: 100%;
  max-width: 720px;
  max-height: 930px;
}

.gallery-modal-container {
  position: relative;
  width: 100%;
  background: #ffffff;
  border-radius: 40px;
  overflow: hidden;
}

.gallery-modal-close {
  position: relative;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  border: 0px;
  background-color: rgb(255, 255, 255);
  font-size: 32px;
  cursor: pointer;
  display: flex;
  margin-left: auto;
  padding: unset;
  padding-top: unset;
  justify-content: center;
  margin-bottom: 16px;
  padding-top: 6px;
  color: #333;
}

.gallery-modal-close:hover {
  background-color: rgba(111, 37, 149, 1);
  color: #fff;
}

.gallery-modal-scroll {
  max-height: 70vh;
  overflow-y: auto;
  padding: 48px 48px 48px 48px;
}

.gallery-modal-title {
  color: #333;
  font-family: 'Codec Warm', sans-serif;
  font-size: 40px;
  font-style: normal;
  font-weight: 600;
  line-height: 60px;
  margin-bottom: 32px;
  margin-top: unset;
}

.gallery-modal-meta {
  color: #333;
  font-family: 'Noto Sans', sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
  margin-bottom: 24px;
}

.gallery-modal-description,
.gallery-modal-description p {
  color: #333 !important;
  font-family: 'Noto Sans', sans-serif !important;
  font-size: 16px !important;
  font-style: normal !important;
  font-weight: 400 !important;
  line-height: 24px !important;
}

.gallery-modal-actions {
  display: flex;
  gap: 32px;
  margin-top: 32px;
  justify-content: space-between;
}

.gallery-modal-tags {
  color: #666;
  font-family: 'Noto Sans', sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
}

.gallery-modal-cta {
  display: flex;
  padding: 16px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  flex: 1 0 0;
  text-align: center;
  font-family: 'Noto Sans', sans-serif;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 27px;
  border-radius: 4px;
  cursor: pointer;
  text-decoration: none;
}

.gallery-modal-cta-primary {
  background: #6f2595;
  color: #fff;
}

.gallery-modal-cta-primary:hover {
  background: rgba(111, 37, 149, 0.9);
}

.gallery-modal-cta-secondary {
  border: 2px solid #6f2595;
  background: #fff;
  color: #6f2595;
}

.gallery-modal-cta-secondary:hover {
  background: #f5f5f5;
}

.gallery-modal-image {
  margin-top: 32px;
}

.gallery-modal-image img {
  object-fit: cover;
  width: 100%;
  border-radius: 9.5px;
  aspect-ratio: 187/105;
}
`;

export { modalPortalCss };
